import { classes, DOM } from '../const';

const { $hbody, $document } = DOM;
const { isActive, isOpen, noOverflow, isVisible, isShrinked } = classes;

const $$menuBtns = $('.js-menu-btn');
const $$closeMenuBtns = $('.js-menu-close');
const $menu = $('.js-site-menu');
const $menuInner = $menu.find('.js-site-menu-inner');
const $menuLinksHolder = $menu.find('.js-menu-links');
const $$menuLinks = $menuLinksHolder.find('.menu-link');
const $$menuAccordions = $('.js-menu-accordion');


let menuOpen = false;

const openMenu = () => {
  menuOpen = true;
  $hbody.addClass(noOverflow);
  $menu.addClass(isOpen);
  $$menuBtns.addClass(isActive);
};

const closeMenu = () => {
  menuOpen = false;
  $hbody.removeClass(noOverflow);
  $menu.removeClass(isOpen);
  $$menuBtns.removeClass(isActive);

  $menuInner.removeClass(isShrinked);
  $menuInner.find('.js-menu-accordion-content').removeClass(isVisible);
  $menuInner.find('.js-menu-accordion-trigger').removeClass(isOpen);
};

const toggleMenu = () => {
  if (menuOpen) {
    closeMenu();
  } else {
    openMenu();
  }
};

const initMenuAccordion = ($el) => {
  const $trigger = $el.find('.js-menu-accordion-trigger');
  const $content = $el.find('.js-menu-accordion-content');

  $trigger.click(event => {
    event.preventDefault();
    $el.toggleClass(isOpen);
    $$menuAccordions.each((i,accordion) => {
      if(accordion !== $el[0]){
        $(accordion).removeClass(isOpen);
        $(accordion).find('.js-menu-accordion-content').removeClass(isVisible);
      }
    });

    if ($el.hasClass(isOpen)) {
      $menuInner.addClass(isShrinked);
      $content.addClass(isVisible);
    } else {
      $menuInner.removeClass(isShrinked);
      $content.removeClass(isVisible);
    }
  });
};

const siteMenu = () => {

  $$menuBtns.each((i, el) => {
    $(el).click(event => {
      event.preventDefault();
      toggleMenu();
    });
  });


  $$closeMenuBtns.each((i, el) => {
    $(el).click(event => {
      event.preventDefault();
      closeMenu();
    });
  });

  $$menuAccordions.each((i, el) => {
    initMenuAccordion($(el));
  });

  $document.keydown(event => {
    if (event.which === 27 && menuOpen) {
      closeMenu();
    }
  });
};

export default siteMenu;

